export const contextMenuItems = [
    { text: 'Remove Custom Column', target: '.e-gridheader', id: 'removecustomcolumn', enabled: false },
];

const getCustomColumn = (fieldName, customColumns) => {
    if (!fieldName) {
        return null; // Return null if fieldName is undefined or falsy
    }
    return customColumns.find(col => {
        const fieldnameExpectedStart = col.config.fieldName;
        return fieldName.startsWith(fieldnameExpectedStart);
    });
};

export const handleContextMenuClick = (args, customColumns, setCustomColumns) => {
    if (args.item.id === 'removecustomcolumn' && !args.item.disabled) {
        const customCol = getCustomColumn(args.column?.field, customColumns);
        if (customCol) {
            removeCustomColumn(customCol.config.fieldName, customColumns, setCustomColumns);
        }
    }
};

const removeCustomColumn = (fieldName, customColumns, setCustomColumns) => {
    // Filter out the column config and update the state
    const updatedCustomColumns = customColumns.filter(col => col.config.fieldName !== fieldName);
    setCustomColumns(updatedCustomColumns);
};

export const handleContextMenuOpen = (args, grid, customColumns, isDayDataOpen) => {
    const itemToEnable = contextMenuItems.find(item => item.id === 'copy');

    // If the item is found, update its 'enabled' property
    if (itemToEnable) {
        itemToEnable.enabled = true;
    }

    const customCol = getCustomColumn(args.column?.field, customColumns);
    const isACustomColumn = Boolean(customCol);
    grid.current.contextMenuModule.contextMenu.enableItems(
        ["Remove Custom Column"],
        isACustomColumn && isDayDataOpen
    );
};
